import { createTheme } from '@mui/material/styles';
import { baseTheme } from '@/core/theme/baseTheme';

/**
 * 愛媛マラソン 2026 テーマ
 * ベーステーマにカラーを上書き
 */
export const ehime2026Theme = createTheme(baseTheme, {
  palette: {
    primary: {
      main: '#FF8800',
      contrastText: '#FFFFFF',
    },
    secondary: {
      main: '#6A2BFF',
      contrastText: '#FFFFFF',
    },
  },
  custom: {
    gradient: 'linear-gradient(135deg, #FF8800 0%, #6A2BFF 100%)',
    adminGradient: 'linear-gradient(135deg, #6A2BFF 0%, #FF8800 100%)',
  },
});
